var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42I = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M22.5 48.003a2.5 2.5 0 0 1-2.5-2.5v-31a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v31a2.5 2.5 0 0 1-2.5 2.5h-15ZM54 35v10l-8.274.752A2.5 2.5 0 0 1 43 43.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 34 .445.223A2.813 2.813 0 0 1 54 36.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 46"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 25V15l8.274-.752A2.5 2.5 0 0 1 17 16.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 26-.445-.223A2.813 2.813 0 0 1 6 23.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 14"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 15v10l-8.274.752A2.5 2.5 0 0 1 43 23.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 14 .445.223A2.813 2.813 0 0 1 54 16.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 26"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 45V35l8.274-.752A2.5 2.5 0 0 1 17 36.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 45Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 46-.445-.223A2.813 2.813 0 0 1 6 43.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 34"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m34.895 22.828-3.63 13.381h-.143l-3.463-13.38H24l4.909 17.36h2.683l4.96-17.352-1.657-.009Z"
})));
SvgRectangle42I.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42I);
export default ForwardRef;